import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractService } from '@core/http/abstract.service';

import { PaymentApiResponse } from './payment.entity';

@Injectable({
  providedIn: 'root'
})
export class PaymentService extends AbstractService {
  protected override prefix = '/payments';

  getRegions(locale: string): Observable<PaymentApiResponse.Regions> {
    return this.get<PaymentApiResponse.Regions>('/regions', { locale });
  }

  getRegionTabs(regionId: number): Observable<PaymentApiResponse.RegionTabs> {
    return this.get<PaymentApiResponse.RegionTabs>(`/regions/${ regionId }/tabs`);
  }

  getGiftCodes(): Observable<PaymentApiResponse.GiftCodes> {
    return this.get<PaymentApiResponse.GiftCodes>('/gift-codes');
  }

  createInvoice(
    methodId: number,
    amountUsd: number,
    wallet: string | null,
    cid: string,
    sid: number|null,
    ycid: string|null
  ): Observable<PaymentApiResponse.PaymentInvoice> {
    return this.post<PaymentApiResponse.PaymentInvoice>(
      `/methods/${ methodId }/create-invoice`,
      {
        amountUsd,
        wallet,
        cid,
        sid,
        ycid
      },
      {
        throwError: true
      }
    );
  }

  useGiftCode(code: string): Observable<PaymentApiResponse.GiftCodeApplied> {
    return this.post<PaymentApiResponse.GiftCodeApplied>('/gift-codes/use', { code }, { throwError: true });
  }

  getPaymentHistory(): Observable<PaymentApiResponse.PaymentHistory> {
    return this.get<PaymentApiResponse.PaymentHistory>('/history');
  }
}
